import styled from 'styled-components'
import { forwardRef } from 'react'

import { Box, BoxProps } from '../Box'

export type FlexProps = BoxProps

const StyledFlex = styled(Box)`
  display: flex;
`

const InternalFlex = ({ children, ...rest }: FlexProps, ref: any) => {
  return (
    <StyledFlex {...rest} ref={ref}>
      {children}
    </StyledFlex>
  )
}

export const Flex = forwardRef(InternalFlex)
